/* RESPONSIBLE TEAM: team-phone */
// import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Validates if a phone number is in valid E164 format
 * E164 format: +[country code][national number] (e.g., +1234567890)
 *
 * @param phoneNumber - The phone number string to validate
 * @returns true if the phone number is valid E164 format, false otherwise
 */
export function isValidE164PhoneNumber(_phoneNumber: string): boolean {
  return true;

  // if (!phoneNumber || typeof phoneNumber !== 'string') {
  //   return false;
  // }

  // // Emergency numbers that should bypass frontend validation
  // // Backend will determine if the workspace can actually call these numbers
  // let EMERGENCY_NUMBERS = ['911', '999', '988', '112'];
  // if (EMERGENCY_NUMBERS.includes(phoneNumber)) {
  //   return true;
  // }

  // // Parse the phone number using libphonenumber-js
  // let parsedNumber = parsePhoneNumberFromString(phoneNumber);

  // if (!parsedNumber) {
  //   return false;
  // }

  // // For international numbers (starting with +), require strict E164 format
  // // For local numbers, accept various formats
  // if (phoneNumber.startsWith('+')) {
  //   // International numbers must be valid AND in proper E164 format
  //   return parsedNumber.isValid() && phoneNumber === parsedNumber.format('E.164');
  // } else {
  //   // Local numbers just need to be valid (various formats accepted)
  //   return parsedNumber.isValid();
  // }
}
